import React from 'react';
import PropTypes from 'prop-types';
import { consistentString } from '../../utils/content-formatting';
// Components
import InlineCallOut from './inline-callout';
import SimpleRichText from '../rich-text/simple';
import WebchatInlineCallout from '../webchat/inline-callout';

const InlineCalloutAssembly = ({ contentfulData }) => {
  if (contentfulData.type === 'Webchat status') {
    return (
      <WebchatInlineCallout
        icon={contentfulData.icon}
        borderColor={
          consistentString(contentfulData.borderColor) === 'default'
            ? 'red'
            : consistentString(contentfulData.borderColor)
        }
        bannerColor={
          consistentString(contentfulData.bannerColor) === 'default'
            ? 'grey'
            : consistentString(contentfulData.bannerColor)
        }
        removeMarginBottom={contentfulData.removeMarginBottom}
      />
    );
  }
  return (
    <InlineCallOut
      icon={contentfulData.icon}
      borderColor={
        consistentString(contentfulData.borderColor) === 'default'
          ? 'red'
          : consistentString(contentfulData.borderColor)
      }
      bannerColor={
        consistentString(contentfulData.bannerColor) === 'default'
          ? 'grey'
          : consistentString(contentfulData.bannerColor)
      }
      removeMarginBottom={contentfulData.removeMarginBottom}
    >
      <SimpleRichText richText={contentfulData.content} />
    </InlineCallOut>
  );
};

InlineCalloutAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

InlineCalloutAssembly.displayName = 'InlineCalloutAssembly';

export default InlineCalloutAssembly;
